// Sync pricing card visuals with variant selection
document.addEventListener('DOMContentLoaded', function() {
  
  // Helper function to update pricing card visuals only
  function updatePricingCardVisuals() {
    // Find all checked inputs
    const checkedInputs = document.querySelectorAll('input[name^="option"]:checked');
    
    // Reset all pricing card visuals first
    document.querySelectorAll('.pricing-card__item').forEach(label => {
      label.classList.remove('pricing-card--selected');
    });
    
    // Set visuals for checked inputs
    checkedInputs.forEach(input => {
      // Find corresponding pricing card labels
      document.querySelectorAll('.pricing-card__item').forEach(label => {
        const forId = label.getAttribute('for');
        const pricingInput = document.getElementById(forId);
        
        if (pricingInput && 
            pricingInput.name.replace(/_.*$/, '') === input.name.replace(/_.*$/, '') && 
            pricingInput.value === input.value) {
          label.classList.add('pricing-card--selected');
        }
      });
    });
  }
  
  // Initial load
  setTimeout(updatePricingCardVisuals, 200);
  
  // Listen to theme's variant changes (don't interfere with inputs)
  document.addEventListener('change', function(event) {
    if (event.target.matches('input[name^="option"]')) {
      setTimeout(updatePricingCardVisuals, 10);
    }
  });
  
  // Handle pricing card clicks (let theme handle the actual input logic)
  document.addEventListener('click', function(event) {
    if (event.target.closest('.pricing-card__item')) {
      const label = event.target.closest('.pricing-card__item');
      const forId = label.getAttribute('for');
      const input = document.getElementById(forId);
      
      if (input) {
        // Let the theme handle the input logic, just update visuals after
        setTimeout(updatePricingCardVisuals, 10);
      }
    }
  });
});
